import { render, staticRenderFns } from "./EditTransaksi.vue?vue&type=template&id=63f2474c"
import script from "./EditTransaksi.vue?vue&type=script&lang=js"
export * from "./EditTransaksi.vue?vue&type=script&lang=js"
import style0 from "./EditTransaksi.vue?vue&type=style&index=0&id=63f2474c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports